/*
 * @Description: 广告
 * @Author: zhongshanxian01
 * @Date: 2021-05-25 10:52:29
 * @LastEditors: zhongshanxian01
 * @LastEditTime: 2021-05-25 16:35:31
 */
import setLog from '@utils/log';
import React from 'react';
import { catchable } from '@components/catchable';

function ADBanner(props) {
    const { bannerInfo, index, pcOpenMode } = props;
    return (
        <div
            className={`banner${index == 0 ? ' first' : ''}`}
            key={'module' + bannerInfo.id}
            index={index}
            id={bannerInfo.id}
        >
            {bannerInfo.content.map((adItem, adIndex) => {
                if (!adItem.url)
                    return (
                        <img
                            key={'ad' + adItem.id}
                            src={adItem.img}
                            className={adIndex == 0 ? 'first' : ''}
                        />
                    );
                return (
                    <a
                        key={'ad' + adItem.id}
                        href={adItem.url}
                        target={pcOpenMode == 'this' ? '_self' : '_blank'}
                        onClick={() => {
                            setLog.set({
                                id: 'clk_web_106_2',
                                info: {
                                    link_url: adItem.url,
                                    modular_name: bannerInfo.module_name,
                                    module_id: bannerInfo.id
                                }
                            });
                        }}
                    >
                        <img src={adItem.img} className={adIndex == 0 ? 'first' : ''} />
                    </a>
                );
            })}
        </div>
    );
}

export default catchable(ADBanner);
